const EARTH_RADIUS_M = 6371000;

/**
 * Compute approximate area in acres from lat/lng polygon using the Shoelace formula
 * with spherical earth correction. Accuracy is ±1-2% for properties under 500 acres.
 * Returns 0 for degenerate polygons (fewer than 3 points).
 */
export function computeAcreage(points: [number, number][]): number {
  if (points.length < 3) return 0;

  const toRad = (deg: number) => (deg * Math.PI) / 180;
  let area = 0;
  const n = points.length;

  for (let i = 0; i < n; i++) {
    const [lat1, lng1] = points[i];
    const [lat2, lng2] = points[(i + 1) % n];
    const dLng = toRad(lng2 - lng1);
    area += dLng * (Math.sin(toRad(lat1)) + Math.sin(toRad(lat2)));
  }

  const areaM2 = Math.abs((area * EARTH_RADIUS_M * EARTH_RADIUS_M) / 2);
  const M2_PER_ACRE = 4046.856;
  return areaM2 / M2_PER_ACRE;
}
